import Config from "@app/constants/Config";
import { authMiddleware } from "@app/utils/helper";

export async function load() {
	console.log("load", Config.API.INSPECTION.LOAD);
	const response = await fetch(Config.API.INSPECTION.LOAD, {
		credentials: "include",
	});
	await authMiddleware(response);
	return await response.json();
}

export async function save(uuid, data) {
	const {
		values,
		meta,
		type,
		status,
		branch,
		dispatcher,
		officeId,
		officeName,
		companyId,
		companyName,
		visitDate,
		followupDate,
		followupInspection,
	} = data;

	const payload = {
		uuid,
		dataType: type,
		status,
		branch,
		dispatcher,
		visitDate,
		followupDate,
		followupInspection,
		officeId,
		officeName,
		companyId,
		companyName,
		formData: JSON.stringify({ values, meta }),
	};

	const call = () =>
		fetch(Config.API.INSPECTION.SAVE, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			credentials: "include",
			body: JSON.stringify(payload),
		});

	const response = await call();
	return response;
}

export async function remove(uuid) {
	const response = await fetch(Config.API.INSPECTION.DELETE + `&formId=${uuid}`, {
		credentials: "include",
	});
	await authMiddleware(response);
	return response.json();
}
